import { constants } from '../Constants'
import { Box, Button } from '@mui/material'
import LaunchIcon from '@mui/icons-material/Launch'
import { registration } from '../../bedManagement/endpoints/EndPoints'

const MapNewPatientform = () => {
  const handleOpenRegistration = () => {
    open(registration, '_blank', 'rel=noopener noreferrer')
  }

  return (
    <Box marginY={1}>
      <Button
        variant='contained'
        endIcon={<LaunchIcon />}
        onClick={handleOpenRegistration}
      >
        {constants?.openRegistration}
      </Button>
    </Box>
  )
}

export default MapNewPatientform
